import {Grid} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import type {SectionProps as Props} from '@yandex-delivery/form'
import {renderWidget} from '@yandex-delivery/form/ui/OrderForm/widgets'
import * as classes from '@yandex-delivery/form/ui/OrderForm/widgets/Verticals/Verticals.classes'
import type {ReactElement} from 'react'

export function VerticalsSection({section}: Props): ReactElement {
  const i18n = useI18n()

  return (
    <>
      <Grid xs={12} item>
        <div className={classes.wrapper.formTitle}>
          <span className={classes.formTitle}>{i18n('order.form.verticals.title', 'Новый заказ')}</span>
        </div>
      </Grid>
      {section.widgets.map(renderWidget)}
    </>
  )
}
